import { CollectionAssetType } from '@imcc/transport';
// eslint-disable-next-line import/no-cycle
import { OrderAsset } from '../orders/order-asset';
import { SourceAsset } from './source-asset';

export class CollectionAsset {
  assetType: CollectionAssetType;

  name: string;

  sourceAssetId: string;

  sourceAsset: SourceAsset;

  // eslint-disable-next-line max-len
  static fromOrderAssets = (assets: OrderAsset[]): CollectionAsset[] => assets.map(CollectionAsset.fromOrderAsset);

  static fromOrderAsset = (asset: OrderAsset): CollectionAsset => {
    const collectionAsset = new CollectionAsset();
    collectionAsset.name = asset.sourceAsset.name;
    collectionAsset.assetType = asset.assetType;
    collectionAsset.sourceAsset = asset.sourceAsset;

    return collectionAsset;
  };
}
